import { RouteRecordRaw } from 'vue-router';
// import { RouterView } from 'vue-router';

export const palettenkontoRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('../pages/_layout/PalettenkontoLayout.vue'),
    meta: { scope: 'palettenkonto', title: 'WMS Palettenkonto' },
    children: [
      { path: '', name: 'palettenkonto.stocks', component: () => import('../pages/StocksView.vue') },
      { path: '/stock/:id', name: 'palettenkonto.stocks.details', component: () => import('../pages/StockDetailsView.vue'), props: true },
      { path: '/articles', name: 'palettenkonto.articles', component: () => import('../pages/ArticlesView.vue') },
      { path: '/owners', name: 'palettenkonto.owners', component: () => import('../pages/OwnersView.vue') },
      { path: '/standorte', name: 'palettenkonto.standorte', component: () => import('../pages/StandorteView.vue') },
      { path: '/lieferungen', name: 'palettenkonto.lieferungen', component: () => import('../pages/LieferungenView.vue') },
      { path: '/document-templates', name: 'palettenkonto.document-templates', component: () => import('../pages/DocumentTemplatesView.vue') },
      {
        path: '/document-templates/:id',
        name: 'palettenkonto.document-templates.editor',
        component: () => import('../pages/DocumentTemplateEditorView.vue'),
        props: true,
      },
    ],
  },
];
